import { Game, HistoryDay, SeasonStats } from '../types';

export const SEASON_STATS: SeasonStats = {
  played: 0,
  noHR: 0,
  rate: 0,
  accuracy: 0,
  streak: 0,
  pl: '0u',
};

export const HISTORY: HistoryDay[] = [];

export const MOCK_GAMES: Game[] = [
  {
    id: 1,
    away: 'SF Giants', home: 'Pittsburgh',
    awayAbbr: 'SFG', homeAbbr: 'PIT',
    venue: 'PNC Park', time: '6:40 PM',
    prob: 31, strong: true,
    awayPitcher: 'Logan Webb', homePitcher: 'Mitch Keller',
    awayHR9: 0.61, homeHR9: 0.58,
    factors: {
      park:    { label: 'Park Factor',  value: '−0.78', sub: 'PNC Park · strong HR suppressor',       score: 90, dir: 'good'    },
      pitcher: { label: 'SP HR/9 Avg',  value: '0.60',  sub: 'Webb 0.61 · Keller 0.58',               score: 83, dir: 'good'    },
      slg:     { label: 'Team SLG Avg', value: '.397',  sub: 'SFG .401 · PIT .393',                   score: 57, dir: 'neutral' },
      total:   { label: 'Game Total',   value: '7.0',   sub: 'Low total · very favorable',            score: 80, dir: 'good'    },
      weather: { label: 'Weather',      value: '62°F',  sub: '8mph IN ↓',                             score: 74, dir: 'good'    },
    },
    tags: [
      { label: 'Park 0.78', type: 'good' },
      { label: 'Wind IN 8mph', type: 'good' },
      { label: 'Webb 0.61', type: 'good' },
      { label: 'O/U 7.0', type: 'good' },
    ],
  },
];
